import React from 'react'

const SpreadsheetIcon = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 0H4.4C3.76348 0 3.15303 0.252852 2.70295 0.702948C2.25285 1.15303 2 1.76348 2 2.4V21.6C2 22.2365 2.25285 22.8469 2.70295 23.297C3.15303 23.7472 3.76348 24 4.4 24H18.8C19.4365 24 20.0469 23.7472 20.497 23.297C20.9472 22.8469 21.2 22.2365 21.2 21.6V7.2L14 0ZM18.8 21.6H4.4V2.4H12.8V8.4H18.8V21.6ZM9.2 13.2H5.6V10.8H9.2V13.2ZM14 13.2H10.4V10.8H14V13.2ZM9.2 16.8H5.6V14.4H9.2V16.8ZM14 16.8H10.4V14.4H14V16.8ZM9.2 20.4H5.6V18H9.2V20.4ZM14 20.4H10.4V18H14V20.4Z" />
    </svg>
  )
}

export default SpreadsheetIcon
